<template>
  <div class="header"  v-if="!isHideMenu" @mouseleave="itemMenuLeave($event)"
    :class="[isTransparent ? 'headerTransparent' : '', audoShadow ? 'headerShadow' : '', isParty ? 'partyHeader' : '', isHr ? 'hrHeader' : '',device == 'mobile' ? 'header-mobile1' :'']">
    <div class="containers">

      <div class="content">
        <div class="searchBox" :class="[isSearch ? 'searchBoxMax' : '', searchPage ? 'searchBoxPageMax' : '']">
          <v-text-field :placeholder="$t('InputKeyword')" v-model="homeKeyword" @keydown="keyDownHandler">
            <v-icon slot="prepend" color="block">
             {{icons.mdiMagnify}}
            </v-icon>
            <v-icon slot="append" color="block"  @click="closeSearch">
             {{icons.mdiWindowClose}}
            </v-icon>
<!-- v-if="!searchPage" -->
            <!-- <v-btn slot="append" v-if="searchPage" @click="searchPageHandler">
              {{ $t('Search') }}
            </v-btn> -->

          </v-text-field>
        </div>
        <img v-if="!isParty && !isHr" src="../assets/img/headerLogo@2x.png" class="logo" />
        <img v-else src="../assets/img/whitgelogodaan@2x.png" class="logo" />
        <div class="center">
          <template v-if="!isSearch">
            <div class="navitem" @mouseenter="itemMenuEnter($event, index)" @click="menuHandler(index, item)"
              :class="[menuCode == item.code ? 'activeNavitem' : '']" v-for="(item, index) in menuList" :key="index">
              {{ item.columnName }}
            </div>
          </template>
        </div>
        <div class="tools" :class="[isParty || isHr ? 'whitetools' : '']">
          <div class="toolsitem" @click.stop="searchHandler">

            <img v-if="!isParty && !isHr" src="../assets/img/search@2x.png" class="search" />
            <img v-else src="../assets/img/whitesearch@2x.png" class="search" />

          </div>
          <div class="toolsitem">
            <ChangeLanguage :is-party="isParty" :is-hr="isHr" />
            <!-- <img v-if="!isParty && !isHr" src="../assets/img/lang@2x.png" class="lang" />
            <img v-else src="../assets/img/whitelang@2x.png" class="lang" />
            <span>语言</span> -->
          </div>
          <div class="toolsitem" @click="openMenu">
            <img v-if="!isParty && !isHr" src="../assets/img/langico@2x.png" class="langico" />
            <img v-else src="../assets/img/whitelangico@2x.png" class="langico" />
          </div>
        </div>
      </div>
    </div>
    <div class="dropcontent animate__animated animate__fadeInLeft" v-if="isMenuShow">
      <div class="containers">
        <div class="droplist">
          <div class="dropleft">
            <div class="droplefttitle">
              {{ dropList.columnName }}
            </div>
            <div class="dropleftdes">
              {{ dropList.content }}
            </div>
            <img v-if="dropList.imgFile" :src="dropList.imgFile.url" class="dropleftcover" />
          </div>
          <div class="dropright"
            :class="[dropList.code && (dropList.code.indexOf('MAJOR') > -1) ? 'droprightList' : '']">
            <div class="droprightitem" v-for="(item, index) in dropList.menu" :key="index">
              <div class="titleinfo" @click="dropItemHandler(item)">
                <template v-if="$i18n.locale == 'en'">
                  <div class="droptitle line-3" :class="[`droptitle-${$i18n.locale}`]">
                    {{ item.columnName }}
                  </div>
                </template>
                <template v-else>
                  <div class="droptitle line-1">
                    {{ item.columnName }}
                  </div>
            
                </template>
                <v-icon class="droparrow" small>{{ icons.mdiChevronRight }}</v-icon>
              </div>
              <div class="droprightListContent" v-if="item.code && (item.code.indexOf('MAJOR') > -1)">
                <template v-if="$i18n.locale == 'en'">
                  <div class="droprightListContentItem line-3"  :class="[`droprightListContentItem-${$i18n.locale}`]" @click="dropDetailHandler(sitem, item)"
                    v-for="(sitem, sindex) in item.menu" :key="sindex">
                    {{ sitem.columnName }}
                  </div>
                </template>
                <template v-else>
                  <div class="droprightListContentItem line-1" @click="dropDetailHandler(sitem, item)"
                    v-for="(sitem, sindex) in item.menu" :key="sindex">
                    {{ sitem.columnName }}
                  </div>
                </template>
              </div>
              <!-- <div class="des">{{ item.content }}</div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 点击菜单弹框 -->
    <div class="topDialogMenu" v-if="isTopMenuShow">

      <div class="headerTop">
        <div class="containers">
          <img src="../assets/img/whitgelogodaan@2x.png" class="logodaa" />
          <!-- mdiClose -->
          <v-icon large @click="closeMenu" class="menuClose">{{ icons.mdiClose }}</v-icon>
        </div>
      </div>
      <div class="headerBottom">
        <div class="containers">
          <div class="menuList" :class="[`menuList-${$i18n.locale}`]">
            <div class="menuListItem" :class="['menuListItem-' + $i18n.locale]" v-for="(item, index) in topMenuList"
              :key="index">
              <div class="label line-1">
                {{ item.columnName }}
              </div>
              <div class="chrenList">
                <div class="chrenListItem line-1" :class="[`chrenListItem-${$i18n.locale}`]" @click="topHeader(sitem, item)" v-for="(sitem, sindex) in item.menu"
                  :key="sindex">
                  {{ sitem.columnName }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex';
import ChangeLanguage from '@/i18n/changeLanguage.vue';
export default {
  name: 'HeaderVue',
  
  components: {
    ChangeLanguage
  },
  data() {
    return {
      homeKeyword: '',
      isSearch: false,
      searchPage: false,
      isTopMenuShow: false,
      isMenuShow: false,
      dropList: {
        menu: []
      },
      scrollDistance: 0,
      isHideMenu:false,
      isTransparent: false,
      isHr: false,
      isParty: false,//是否党建
      hoverIndex: 0,
      menuIndex: 0,
      menuCode:'INDEX',
      topMenuList: [],
      menuList: []
    }
  },
  computed: {
    ...mapState({
      device: state => state.app.device
    }),
    audoShadow() {
      if (this.scrollDistance > 150) {
        return true
      } else {
        return false
      }
    }
  },
  mounted() {
    window.addEventListener('scroll', this.initScroll)
    // 修复：将 updateMenuData 监听从 initScroll 移到 mounted，
    // 确保组件挂载后始终能响应菜单数据更新，而非仅在滚动后才注册监听
    this.$Bus.$on('updateMenuData', () => {
      this.initMenu()
    })
  },
  beforeDestroy(){
    window.removeEventListener('scroll', this.initScroll)
    this.$Bus.$off('updateMenuData')
  },
  watch: {
    '$route': {
      handler(to) {
        this.$nextTick(() => {
          // 处理关键字问题
          if (this.$route.query.keyword) {
            this.homeKeyword = this.$route.query.keyword
          }
          // getMenu() 已在 App.vue 的 $route 监听中统一调用，此处不再重复请求
          this.getHomeIndex()
          this.initMenu()


          this.expand = true
          if (to.path == '/search/index') {
            this.isSearch = true
            this.searchPage = true
          } else {
            this.searchPage = false
          }
          if (to.path.indexOf('/about/list') > -1) {
            this.isTransparent = false
          } else {
            this.isTransparent = false
          }
          if (to.path == '/about/list/hr') {
            this.isHr = false
          } else {
            this.isHr = false
          }
          if (to.path.indexOf('/party/building') > -1) {
            this.isParty = true
          } else {
            this.isParty = false
          }
          if(this.menuList && this.menuList.length){
            this.menuList.forEach((item, index) => {
              if (item.url == to.path || to.path.indexOf(item.url) > -1) {
                this.menuIndex = index
                this.menuCode = item.code
              }
              if(to.path.indexOf('cora') > -1){
                this.menuIndex = this.menuList.findIndex((item) => item.code == 'SERVICE')
                this.menuCode = this.menuList[this.menuIndex]['code']
              }
              if(to.name == 'informationListCode' ){
                this.menuIndex = this.menuList.findIndex((item) => item.code == 'INFOS')
                this.menuCode = this.menuList[this.menuIndex]['code']
              }

            })
          }
          console.log(this.menuIndex,this.menuCode,'header')
          this.$forceUpdate()
        })

      },
      deep: true, // 深度监听
      immediate: true, // 第一次初始化渲染就可以监听到
    }
  },
  methods: {
    initScroll(){
      // 获取页面滚动距离
      var scrollDistance = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      console.log(scrollDistance,'scrollDistance===')
      this.scrollDistance = scrollDistance
      if(this.scrollDistance > 400){
        console.log(this.$route.path,'this.$route.path == ')
        if(this.$route.path == '/service/list' || this.$route.path == '/expertise/list/detail'){
          this.isHideMenu = true
        }else{
          //处理走送达安的逻辑也需要
          if(this.$route.path == '/about/list' && this.$route.path.indexOf('hr') == -1){
            this.isHideMenu = true
          }else{
            this.isHideMenu = false
          }
        }
      }else{
        this.isHideMenu = false
      }
    },
    initMenu(){
      var topMenuList = JSON.parse(localStorage.getItem('footerLists'))
        if(topMenuList){
          if (this.$i18n.locale == 'en') {
            topMenuList = topMenuList.filter((item) => item.code != 'CONSTRUCT')
          }
          this.topMenuList = topMenuList
          var menuList = JSON.parse(localStorage.getItem('menuLists'))
          if (this.$i18n.locale == 'en') {
            menuList = menuList.filter((item) => item.code != 'CONSTRUCT')
          }
          this.menuList = menuList
        }
    },
    searchPageHandler() {
      this.$Bus.$emit('searchEvent', this.homeKeyword)
    },
    keyDownHandler(e) {
      console.log(e)
      if (e.keyCode == 13) {
        this.$router.push({
          path: `/search/index?keyword=` + this.homeKeyword
        })
      }
    },
    searchHandler() {
      this.isMenuShow = false
      this.isSearch = true
    },
    closeSearch() {
      if (this.searchPage) {
        this.$router.push({
          path: `/`
        })
        return
      }
      this.isSearch = false
    },
    dropDetailHandler(item, pitem) {
      console.log(item, pitem)
      if (pitem.code == 'MAJOR_2') {
        this.$router.push({
          path: pitem.url
        })
      } else {
        this.$router.push({
          path: `/expertise/list/detail?id=${item.id}&code=${pitem.code}`
        })
      }
    },
    openMenu() {
      this.isTopMenuShow = true
    },
    closeMenu() {
      this.isTopMenuShow = false
    },
    itemMenuEnter(e, index) {
      this.hoverIndex = index
      this.dropList = this.menuList[index]
      console.log(this.dropList, ' this.dropList==')
      if (index == 0) {
        this.isMenuShow = false
        return
      }

      this.isMenuShow = true
      console.log(index, 'in')
    },
    itemMenuLeave(e, index) {
      this.isMenuShow = false
      console.log(index, 'out')
    },
    menuHandler(index, item) {
      if (item.url) {
        this.menuIndex = index
        this.menuCode = item.code
        this.$router.push({
          path: item.url
        })
      }
    },
    //弹出菜单处理
    dropItemHandler(item) {
      this.isMenuShow = false
      if (this.dropList && this.dropList.code == 'SERVICE') {
        console.log(item,'item==')
        if(item.code && item.code == 'YYLL'){
          this.$router.push({
            path: '/service/cora?styleValue=0'
          })
        }else{
          this.$router.push({
            path: '/service/list?id=' + item.id
          })
        }
      } else {
        if (item.code.indexOf('INFOS') > -1) {
          this.$router.push({
            path: item.url
          })
        } else {
          if (item.url) {
            this.$router.push({
              path: item.url
            })
          }
        }
      }
    },
    topHeader(item, pitem) {
      console.log(item, 'item==')
      if (pitem.code == 'SERVICE') {
        this.isMenuShow = false
        this.$router.push({
          path: '/service/list?id=' + item.id
        })
      } else {
        if (item.url) {
          this.isTopMenuShow = false
          this.$router.push({
            path: item.url
          })
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  width: 100%;
  height: 100px;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 10000;
  background: white;
  -webkit-box-shadow: 0 4px 12px rgba(0, 0, 0, .04);
  box-shadow: 0 4px 12px rgba(0, 0, 0, .04);
  display: flex;
  align-items: center;
  transition: all 0.3s;

  .topDialogMenu {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 11000;

    width: 100%;
    display: flex;
    flex-direction: column;
    height: 702px;

    .headerTop {
      width: 100%;
      height: 100px;
      background: rgba($color: #164690, $alpha: 1);

      .containers {
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 100px;
      }

      .logodaa {
        max-width: 25%;
      }

      .menuClose {
        margin-left: auto;
        color:white;
      }

      .menuClose::before {
        color: white !important;
      }
    }

    .headerBottom {
      width: 100%;
      height: 572px;
      background: rgba($color: #164690, $alpha: 0.9);

      .menuList {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        padding: 73px;
        box-sizing: border-box;

        .menuListItem {
          width: calc(100% / 6);

          .label {
            font-weight: 500;
            font-size: 24px;
            color: #FFFFFF;
            padding-right: 15px;
            box-sizing: border-box;
          }

          .chrenList {
            padding-top: 26px;
            box-sizing: border-box;

            .chrenListItem {
              font-weight: 500;
              font-size: 18px;
              color: #8FA8CE;
              line-height: 36px;
              text-align: left;
              cursor: pointer;
              padding-right: 15px;
              box-sizing: border-box;
            }
            .chrenListItem-en{
              font-weight: 400;
              font-size: 16px;
              line-height: 28px;
              margin-bottom:10px;
              color:#CCD7E6;
              white-space: unset!important;
              -webkit-line-clamp:unset!important;
            }
          }
        }

        .menuListItem-en {
          width: calc(100% / 5);
        }
      }
      .menuList-en{
        padding:73px 0px;
      }
    }
  }

  .dropcontent {
    position: absolute;
    left: 0;
    top: 100px;
    width: 100%;
    // height: 294px;
    background: white;
    z-index: 0;
    box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
    background-image: url('../assets/img/topBanner@2x.png');
    background-size: 25% 100%;
    background-position: left center;
    background-repeat: no-repeat;

    .containers {
      .droplist {
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: flex-start;

        .dropleft {
          width: 30%;
          padding-top: 67px;
          padding-bottom: 159px;
          box-sizing: border-box;

          .droplefttitle {
            font-weight: 500;
            font-size: 24px;
            color: #333333;
            text-align: left;
          }

          .dropleftdes {
            margin-top: 18px;
            width: 302px;
            font-weight: 400;
            font-size: 14px;
            color: #666666;
            line-height: 26px;
            text-align: left;
          }

          .dropleftcover {
            margin-top: 60px;
            width: 302px;
          }
        }

        .dropright {
          width: 70%;
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          padding-bottom: 100px;
          box-sizing: border-box;

          .droprightitem {
            width: 25%;
            padding-top: 84px;
            box-sizing: border-box;
            cursor: pointer;

            .titleinfo {
              display: flex;
              flex-direction: row;
              align-items: center;

              .droptitle {
                font-weight: bold;
                font-size: 18px;
                color: #164690;
              }
              .droptitle-en{
                font-weight: 500;
                font-size: 16px;
              }

              .droparrow {
                color: #164690;
                font-size: 20px !important;
              }
            }

            .des {
              margin-top: 20px;
              width: 283px;
              font-weight: 400;
              font-size: 14px;
              color: #333333;
              line-height: 26px;
            }
          }
        }

        .droprightList {
          flex-direction: column;
          flex-wrap: unset;

          .droprightitem {
            width: 100%;

            .droprightListContent {
              padding-top: 30px;
              box-sizing: border-box;
              width: 100%;
              display: flex;
              flex-direction: row;
              flex-wrap: wrap;

              .droprightListContentItem {
                width: 20%;
                font-weight: 400;
                font-size: 14px;
                color: #333333;
                line-height: 36px;
                text-align: left;
              }
              .droprightListContentItem-en {
                width: 33.33%;
                font-weight: 400;
                font-size: 14px;
                color: #333333;
                line-height: 36px;
                text-align: left;
              }
              .droprightListContentItem:hover{
                color: #004098!important;
              }
            }
          }
        }
      }
    }
  }

  .containers {
    .content {
      width: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      position: relative;

      .searchBox {
        position: absolute;
        z-index: 2;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%) scale(0);
        width: 0px;
        height: 58px;
        background: #FFFFFF;
        box-shadow: 0px 3 6px 1px rgba(0, 0, 0, 0.16);
        border-radius: 30px 30px 30px 30px;
        border: 1px solid #C4C4C4;

        :deep(.v-text-field) {
          padding-top: 0px !important;
          margin-top: 0px !important;
          display: flex;
          flex-direction: row;
          align-items: center;
        }

        :deep(.v-text-field__details) {
          display: none !important;
        }

        :deep(.v-input input) {
          height: 58px !important;
          max-height: unset !important;
        }

        :deep(.v-input) {
          font-size: 16px !important;
        }

        :deep(.theme--light.v-text-field > .v-input__control > .v-input__slot:before) {
          display: none !important;
        }
      }

      .searchBoxMax {
        width: 1022px;
        margin-left: 120px;
        transform: translate(-50%, -50%) scale(1);
        transition: all 0.5s ease-in-out;
        padding: 0 20px;
        box-sizing: border-box;

      }

      .searchBoxPageMax {
        :deep(.v-text-field) {
          padding-top: 0px !important;
        }

        :deep(.v-input__prepend-outer) {
          margin-top: 0px !important;
        }
      }

      .logo {
        max-width: 25%;
        // height: 66px;
      }

      .partylogo {
        width: 131px;
      }

      .center {
        width: calc(85% - 331px);
        padding: 0 100px;
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        justify-content: space-between;

        .navitem {
          font-weight: 400;
          font-size: 18px;
          color: #333333;
          cursor: pointer;
          height: 100px;
          line-height: 100px;
          transition: all 0.3s;
        }

        .navitem:hover {
          font-weight: 500;
          font-size: 18px;
          color: #004098;
          position: relative;
          transition: all 0.3s;
        }

        .navitem:hover::after {
          content: '';
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          bottom: 0;
          width: 30px;
          height: 3px;
          background: #004098;
          transition: all 0.3s;
        }

        .activeNavitem {
          font-weight: 500;
          font-size: 18px;
          color: #004098;
          position: relative;
          transition: all 0.3s;

        }

        .activeNavitem::after {
          content: '';
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          bottom: 0;
          width: 30px;
          height: 3px;
          background: #004098;
          transition: all 0.3s;
        }
      }

      .tools {
        width: 15%;
        font-weight: 300;
        font-size: 16px;
        color: #333333;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-end;

        .toolsitem {
          padding: 5px 20px;
          box-sizing: border-box;
          position: relative;
          cursor: pointer;
          display: flex;
          flex-direction: row;
          align-items: center;

          span {
            white-space: nowrap;
          }
        }

        .toolsitem::after {
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
          content: '';
          width: 0;
          height: 10px;
          border: 1px solid #C7C7C7;
        }

        .toolsitem:nth-child(3)::after {
          display: none;
        }


        .search {
          width: 16px;
          height: 16px;
        }


        .lang {
          width: 18px;
          height: 18px;
        }


        .langico {
          width: 24px;
          height: 19px;
        }


      }

      .whitetools {
        color: white;
      }

      .center {
        display: flex;
        flex-direction: row;
        align-items: center;

        .navitem {
          font-weight: 400;
          font-size: 18px;
          color: #333333;
        }

        .activeNavitem {
          font-weight: 500;
          font-size: 18px;
          color: #004098;
        }
      }
    }
  }
}

.headerTransparent {
  background: transparent;
  -webkit-box-shadow: unset;
  box-shadow: unset;
  transition: all 0.3s;
}

.headerShadow {
  background: white;
  -webkit-box-shadow: 0 4px 12px rgba(0, 0, 0, .04);
  box-shadow: 0 4px 12px rgba(0, 0, 0, .04);
  transition: all 0.3s;
}

.partyHeader {
  background: #B51408;
  transition: all 0.3s;

  .containers {
    .content {
      .center {
        .navitem {
          color: white;
        }

        .navitem:hover {
          font-weight: 500;
          font-size: 18px;
          color: white;
          position: relative;
          transition: all 0.3s;
        }

        .navitem:hover::after {
          content: '';
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          bottom: 0;
          width: 30px;
          height: 3px;
          background: white;
          transition: all 0.3s;
        }

        .activeNavitem {
          font-weight: 500;
          font-size: 18px;
          color: white;
          position: relative;
          transition: all 0.3s;

        }

        .activeNavitem::after {
          content: '';
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          bottom: 0;
          width: 30px;
          height: 3px;
          background: white;
          transition: all 0.3s;
        }
      }
    }
  }

}

.hrHeader {
  background: transparent;
  transition: all 0.3s;

  .containers {
    .content {
      .center {
        .navitem {
          color: white;
        }
      }
    }
  }
}
.header-mobile{
  height: 1.0rem;
  .containers{
    .content{
      .logo{
        max-width: unset!important;
        width: 45%;
        margin-left: 0.2rem;
      }
      .tools{
        .toolsitem {
          padding: 0.2rem;
        }
        .toolsitem::after{
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
          content: '';
          width: 0;
          height: 0.35rem;
          border-right: 1px solid #C7C7C7;
        }
        .search {
          width: 0.35rem;
          height: 0.35rem;
        }
        .lang {
          width: 0.35rem;
          height: 0.35rem;
        }


        .langico {
          width: 0.45rem;
          height: 0.35rem;
        }
      }
      .center{
        display: none;
      }
    }
  }
  .topDialogMenu{
    height:unset!important;
    .headerTop{
      padding:0.28rem;
      box-sizing: border-box;
      height: 1rem!important;
      .logodaa {
        max-width: 70%;
      }
    }
    .headerBottom{
      height: 8rem!important;
      overflow-y: auto;
      .menuList {
        flex-wrap: wrap;
        width: 100%;
        padding:0.2rem;
        box-sizing: border-box;
        .menuListItem {
          width: 100%;
          
          .label{
            font-size: 0.32rem;
          }
          .chrenList{
            .chrenListItem{
              font-size: 0.28rem;
              line-height:0.32rem;
              margin-bottom:0.1rem;
            }
          }
        }
      }
    }
  }
}
</style>